(function(){
    Vue.component('v-style', {
        render: function (createElement) {
          return createElement('style', this.$slots.default)
        }
    });

    Vue.component('v-json', {
        methods: {
            parse(str) {
                try {
                    console.log('Try Parse', { str, type: typeof str });

                    const json = JSON.parse(JSON.parse(str));

                    setTimeout(() => {

                        console.log('Json?', json);

                        this.$emit('product-pass', {
                            products: json.products,
                        });
                    }, 1000);

                    return json;
                } catch (error) {
                    console.log('Parse Error', { error });

                    return error;
                }
            }
        },
        render: function (createElement) {
            const textContent = [...this.$slots.default].reduce((jsonString, slot) => {
                return jsonString += slot.text;
            }, '');

            const json = this.parse(textContent);

            console.log('Emit Product Pass', json.products);

            this.$emit('product-pass', {
                products: json.products,
            });

            // console.log('Landing Grid Vue Json Component', { textContent, json }, this.$slots.default, this.$el, this.$root);

            return createElement('style', this.$slots.default)
        }
    });

      
    Vue.component('landing-grid', {
      template: `
        <div>
            <div v-if="loading" :style="{ minHeight: '50vh'}"></div>
            <div class="landing-grid collection-landing__grid landing-grid" v-else>
              <grid-item v-for="(product, index) in products" :handle="product.handle" :key="product.id + '' + index"></grid-item>
            </div>
        </div>
      `,
      props: {
        section: {
            type: String,
            required: false,
        },
        ids: {
            type: String,
            required: false,
        },
        handles: {
            type: String,
            required: false,
        },
        total: {
            type: String,
            required: false,
            default: '50'
        },
        handle: {
          type: String,
          required: false,
        },
        limit: {
            type: Number,
            required: false
        }
      },
      data() {
        return {
          open: false,
          loading: true,
          products: [],
        }
      },
      computed: {},
      methods: {
          async fetchProducts() {
            let starter = (this.products.length) ? 1 : 0;
            let pages = Math.ceil(Number(this.total) / 50);
            for (let i = starter; i < pages; i++) {
                let page = i + 1;
                const response = await fetch(`/collections/${this.handle}?view=json-batch&page=${page}`).then((res) => res.json());
                this.loading = false;
                this.products = [
                    ...this.products,
                    ...response.products
                ];

                // for(let j = 0; j < response.products.length; j++) {
                //     // console.log('Product:', response.products[j]);

                //     this.products.push(response.products[j])
                // }
            }
            // const response = await fetch(`/collections/${this.handle}?view=json-batch`).then((res) => res.json());

            // console.log('Landing Grid Response', this.handle, { pages, products: this.products });

            // this.loading = false;
            // this.products = [...response.products];
          }
      },
      mounted() {
        //   console.log('Landing Grid Mounted',{ ids: this.ids.split(','), handles: this.handles.split(','), section: this.section, limit: this.limit }, this.total,  this.handle);

          const ids = this.ids.split(',');
          const handles = this.handles.split(',');
          if(handles && ids) {
            this.loading = false;
            this.products = [...handles].map((handle, index) => {
                return {
                    handle,
                    id: ids[index]
                }
            })
          }

          this.fetchProducts();
      },
    });

    var app = new Vue({
        el: '#collection',
        data: {
            cache: {}
        },
        methods: {
            async fetchProductByHandle(handle) {
                if(this.cache[handle]) return this.cache[handle];

                const product = await fetch(`/products/${handle}?view=json`).then((res) => res.json());

                this.cache[handle] = product;

                return product;
            },
            handleProductPass(products) {
                console.log('App Handle Product Pass', products);
            },
            parseJson(str) {

                console.log('Parse JSON', str, typeof str);

                if(typeof str === 'object') return str;

                return JSON.parse(str);
            }
        },
        mounted() {
            console.log('Collection Landing Grid App Mounted');
        }
    })

})();